/** AI automation whose prompt a tenant edits — keys the help and settings. */
export const AutomationKind = {
  INVOICE_APPROVAL: 'INVOICE_APPROVAL',
  REQUISITION_APPROVAL: 'REQUISITION_APPROVAL',
  PURCHASE_ORDER_APPROVAL: 'PURCHASE_ORDER_APPROVAL',
  INVOICE_VALIDATION: 'INVOICE_VALIDATION',
  INVOICE_MATCH_CONFIRMATION: 'INVOICE_MATCH_CONFIRMATION'
} as const;

export type AutomationKind = (typeof AutomationKind)[keyof typeof AutomationKind];
